import React from 'react';

import { useUser } from '../../hooks/useUser';

const UserLink = ({ principal }) => {
  const { data: user, isLoading } = useUser({ principal });

  const displayName = isLoading || !user?.profile?.name ? principal : user.profile.name;

  // Fix: URL-encode the principal to prevent URL manipulation
  const safePrincipal = encodeURIComponent(principal);

  return (
    <a href={`https://users.cimpress.io/users/${safePrincipal}`} target="_blank" rel="noopener noreferrer">
      {displayName}
    </a>
  );
};

export default UserLink;
